export * from '@kaidam/fc-shared/src/frontend/store/modules/router'
import defaultModule from '@kaidam/fc-shared/src/frontend/store/modules/router'
export default defaultModule